import React from 'react';
import { hooks } from 'mage-i18n';
import { hooks as coreHooks } from 'mage-core';
import { Typography } from '@klarna/bubble-ui';
const BotWhatDoYouNeedHelpWith = () => {
    const t = hooks.useTranslator();
    const tokenHelper = coreHooks.useTokenHelper();
    // @ts-ignore: tokenHelper can be undefined
    const name = tokenHelper.getGivenName();
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t('helpbot.questions.whatDoYouNeedHelpWithPart1', { name })),
        React.createElement("br", null),
        React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t('helpbot.questions.whatDoYouNeedHelpWithPart2')),
        React.createElement("br", null),
        React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t('helpbot.questions.whatDoYouNeedHelpWithPart3'))));
};
export default BotWhatDoYouNeedHelpWith;
